/**
 * /login — legacy alias for /auth.
 *
 * Kept as a route so marketing pages / previously-shared links keep
 * working. Forwards to the unified /auth flow, preserving any
 * ?redirect=<internal> parameter.
 */

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

function Login() {
  const location = useLocation();
  return <Navigate to={`/auth${location.search}`} replace />;
}

export default Login;
